import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const quickLogin = () => import('./views/quickLogin/index') //快捷登录
const questionAnswer = () => import('./views/questionAnswer/index') //问答分享
const encyclopediaShare = () => import('./views/encyclopediaShare/index') //百科分享
const DownloadGuide = () => import('./views/downloadGuide/index') //下载指导
const newshare = () => import('./views/newshare/index') //app内嵌分享
const systemUpdate = () => import('./views/systemUpdate/index') //版本更新
const agreement = () => import('./views/agreement/index') // 用户协议
const agreement_rb = () => import('./views/agreement_rb/index') // 用户协议
const expertInstrction = () => import('./views/expertInstrction/index') // 专家访问页面
const userPrivacyProtocol = () => import('./views/userPrivacyProtocol/index') //用户协议
const userPrivacyProtocol_rb = () => import('./views/userPrivacyProtocol_rb/index') //用户协议（睿宝）
const farmShare = () => import('./views/farmShare/index') //农庄分享
const farmDetail = () => import('./views/farmDetaile/index') //农庄详情
const farmLists = () => import('./views/farmLists/index') //农庄列表
const review = () => import('./views/review/index') //追溯首页
const reviewDetail = () => import('./views/review/introduce') //追溯详情介绍
const reviewFlow = () => import('./views/review/flow') //追溯流程页
const tjshow = () => import('./views/tjshow/index') //追溯流程页

const ddjPrivacyProtocol = () => import('./views/ddjAgreement/privacyProtocol') //大当家-用户隐私协议
const ddjRegister = () => import('./views/ddjAgreement/register') //大当家-用户注册协议

const useInstruction = () => import('./views/useInstruction/index') //农当家-用户使用手册

const bill = () => import('./views/bill/index') //年度账单
const billShareImg = () => import('./views/bill/billShareImg') //年度账单--分享图片

//文章
const article = () => import('./views/article/index') //文章

//英文
const privacy = () => import('./views/agreement/privacy') //文章
const terms = () => import('./views/agreement/terms') //文章

const activity = () => import('./views/activity/index') //活动报名

const ndjShare = () => import('./views/ndjShare/index') //农当家助农合伙人分析
const course = () => import('./views/course/index') //课程

const router = new Router({
    routes: [
        {
            path: '/quickLogin',
            name: 'quickLogin',
            component: quickLogin,
            meta: {
                title: '手机快捷登录',
            },
        },
        {
            path: '/questionAnswer/:id',
            name: 'questionAnswer',
            component: questionAnswer,
            meta: {
                title: '',
            },
        },
        {
            path: '/encyclopediaShare/:id',
            name: 'encyclopediaShare',
            component: encyclopediaShare,
            meta: {
                title: '',
            },
        },
        {
            path: '/DownloadGuide',
            name: 'DownloadGuide',
            component: DownloadGuide,
            meta: {
                title: '下载指导',
            },
        },
        {
            path: '/newshare',
            name: 'newshare',
            component: newshare,
            meta: {
                title: '分享',
            },
        },
        {
            path: '/systemUpdate',
            name: 'systemUpdate',
            component: systemUpdate,
            meta: {
                title: '版本更新',
            },
        },
        {
            path: '/expertInstrction',
            name: 'expertInstrction',
            component: expertInstrction,
            meta: {
                title: '绘制农当家',
            },
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: agreement,
            meta: {
                title: '用户协议',
            },
        },
        {
            path: '/agreement_rb',
            name: 'agreement_rb',
            component: agreement_rb,
            meta: {
                title: '用户协议',
            },
        },
        {
            path: '/userPrivacyProtocol_rb',
            name: 'userPrivacyProtocol_rb',
            component: userPrivacyProtocol_rb,
            meta: {
                title: '用户协议',
            },
        },
        {
            path: '/userPrivacyProtocol',
            name: 'userPrivacyProtocol',
            component: userPrivacyProtocol,
            meta: {
                title: '用户协议',
            },
        },
        {
            path: '/farmShare',
            name: 'farmShare',
            component: farmShare,
            meta: {
                title: '农庄分享',
            },
        },
        {
            path: '/farmDetail',
            name: 'farmDetail',
            component: farmDetail,
            meta: {
                title: '农庄详情',
            },
        },
        {
            path: '/farmLists',
            name: 'farmLists',
            component: farmLists,
            meta: {
                title: '农庄分享',
            },
        },
        {
            path: '/review',
            name: 'review',
            component: review,
            meta: {
                title: '产品追溯',
            },
        },
        {
            path: '/reviewDetail',
            name: 'reviewDetail',
            component: reviewDetail,
            meta: {
                title: '产品追溯',
            },
        },
        {
            path: '/reviewFlow',
            name: 'reviewFlow',
            component: reviewFlow,
            meta: {
                title: '产品追溯',
            },
        },
        {
            path: '/originVerify',
            name: 'originVerify',
            component: () => import('./views/review/originVerify'),
            meta: {
                title: '原产地验证',
            },
        },
        {
            path: '/tjshow',
            name: 'tjshow',
            component: tjshow,
            meta: {
                title: '当家秀',
            },
        },
        {
            path: '/ddjPrivacyProtocol',
            name: 'ddjPrivacyProtocol',
            component: ddjPrivacyProtocol,
            meta: {
                title: '隐私协议',
            },
        },
        {
            path: '/ddjRegister',
            name: 'ddjRegister',
            component: ddjRegister,
            meta: {
                title: '用户注册协议',
            },
        },
        {
            path: '/useInstruction',
            name: 'useInstruction',
            component: useInstruction,
            meta: {
                title: '用户使用手册',
            },
        },
        {
            path: '/bill',
            name: 'bill',
            component: bill,
            meta: {
                title: '年度账单',
            },
        },
        {
            path: '/billShareImg',
            name: 'billShareImg',
            component: billShareImg,
            meta: {
                title: '年度账单分享',
            },
        },
        {
            path: '/article',
            name: 'article',
            component: article,
            meta: {
                title: '',
            },
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: privacy,
            meta: {
                title: 'Privacy Policy',
            },
        },
        {
            path: '/terms',
            name: 'terms',
            component: terms,
            meta: {
                title: 'Terms of Use',
            },
        },
        {
            path: '/activity',
            name: 'activity',
            component: activity,
            meta: {
                title: '活动报名',
            },
        },
        {
            path: '/ndjShare',
            name: 'ndjShare',
            component: ndjShare,
            meta: {
                title: '助农合伙人',
            },
        },
        {
            path: '/course',
            name: 'course',
            component: course,
            meta: {
                title: '课程',
            },
        },
    ],
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
export default router
